import React from "react";
import { Link } from "react-router-dom";
import "../../assets/generalTrade.css";

const GeneralTradeFooter: React.FC = () => {
  return (
    <footer className="gt-footer">
      <div className="gt-container gt-footer-grid">
        <div className="gt-footer-brand">
          <img
            src="/images/general-trade/logo-lyrazone-general-trading.png"
            alt="Lyra Zone General Trading"
          />
          <p>Bringing Quality Essentials Closer to Every Home.</p>
        </div>

        <div>
          <h4>Explore</h4>
          <Link to="/general-trade">Home</Link>
          <Link to="/general-trade/about">About</Link>
          <Link to="/general-trade/team">Team</Link>
          <Link to="/general-trade/contact">Contact Us</Link>
        </div>

        <div>
          <h4>Contact</h4>
          <a href="tel:+60340501142">+60 3 4050 1142</a>
          <a href="tel:+60102634462">+60 10 263 4462</a>
          <a href="mailto:generaltrade@lyrazone.com.my">
            generaltrade@lyrazone.com.my
          </a>
        </div>
      </div>

      <div className="gt-footer-bottom">
        © {new Date().getFullYear()} Lyra Zone General Trading. All rights reserved.
      </div>
    </footer>
  );
};

export default GeneralTradeFooter;
